module.exports = __webpack_public_path__ + "img/smallcalender.f0a2411f.svg";